import { render } from "./InstructionView.vue?vue&type=template&id=7cc924aa&scoped=true"
import script from "./InstructionView.vue?vue&type=script&lang=js"
export * from "./InstructionView.vue?vue&type=script&lang=js"

import "./InstructionView.vue?vue&type=style&index=0&id=7cc924aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc924aa"]])

export default __exports__